






























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class Verifier extends Vue {
  @Prop({ required: true })
  correctSolution!: boolean;

  @Prop({ required: true })
  showSolution!: boolean;

  @Prop({ required: true })
  tip!: string;
}
